import { render, staticRenderFns } from "./LoginAccountInfo.vue?vue&type=template&id=f350dbb2&scoped=true&"
import script from "./LoginAccountInfo.vue?vue&type=script&lang=js&"
export * from "./LoginAccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./LoginAccountInfo.vue?vue&type=style&index=0&id=f350dbb2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f350dbb2",
  null
  
)

export default component.exports